<template>
    <div class="vat-manager-item" :class="isValueRateEmpty ? '' : 'pb-2'">
        <!-- Anchor icon -->
        <div v-if="!value.is_ecotax" class="containerIcon vat-manager-item__anchor">
            <CompassIcon icon="drag-and-drop" size="medium" type="primary" />
        </div>
        <!-- Activ switch -->
        <div v-if="!value.is_ecotax" class="vat-manager-item__action">
            <el-switch
                v-model="value.is_active"
                :active-color="colors.green"
                :inactive-color="colors.gray"
                class="vat-manager-item__action--switch"
            ></el-switch>
        </div>
        <!-- Label input -->
        <div
            class="vat-manager-item__text"
            :class="{ 'vat-manager-item__text--large': value.is_ecotax }"
        >
            <el-input
                v-if="languageId === 0"
                ref="vatItemInputDefaultLabel"
                v-model="value.label"
                class="wp-10 acenter"
                @blur="
                    () => {
                        $emit('blur');
                    }
                "
            >
            </el-input>
            <el-input v-else ref="vatItemInputLangLabel" v-model="translationLabel" class="wp-10">
            </el-input>
        </div>
        <!-- Rate input -->
        <div ref="rate" class="vat-manager-item__rate">
            <el-input
                ref="vatItemInputRate"
                v-model="value.rate"
                :disabled="!itemCanBeUpdated(value)"
                oninput="this.value = this.value.replace(/[^\d.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
                @blur="
                    rateFormatPrecision(value.rate);
                    onRateBlurEvent();
                "
            >
                {{ value.rate }}
            </el-input>
            <div v-if="!isValueRateEmpty" class="vat-manager-item__rate--alert-msg">
                {{ $l10n.__('Champ manquant') }}
            </div>
        </div>
        <!-- Delete action -->
        <div v-if="!value.is_ecotax" class="vat-manager-item__action vat-manager-item__delete">
            <CompassIconButton
                ref="vatItemButtonDelete"
                :disabled="!itemCanBeDeleted(value)"
                icon="bin"
                @click="removeTaxe(value)"
            />
        </div>
    </div>
</template>

<script>
import colors from '@sellsy/styleguide/src/_export.scss';
import { checkNotBlank } from 'vcomponents/forms/rules/Rules';
import FormMixins from 'mixins/FormMixins';
export default {
    mixins: [FormMixins],
    props: {
        value: {
            type: Object,
            required: true,
        },
        languageId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            translationLabel: '',
            colors: {
                green: colors['success-50'],
                gray: colors['gray-80'],
            },
            rules: {
                rate: [{ validator: checkNotBlank, message: this.$l10n.__('Champ manquant') }],
            },
        };
    },
    computed: {
        updateTranslationLabel: {
            get() {
                return this.value.translations.find((_item) => _item.lang_id === this.languageId)
                    .value;
            },
        },
    },
    watch: {
        languageId() {
            try {
                this.translationLabel = this.updateTranslationLabel;
            } catch (error) {}
        },
        translationLabel(newValue) {
            this.updateTranslationValue(newValue);
        },
    },
    created() {
        this.value.rate = Number(this.value.rate);
    },

    methods: {
        updateTranslationValue(value) {
            this.value.translations.find((_item) => _item.lang_id === this.languageId).value =
                value;
        },
        removeTaxe() {
            this.$emit('remove-taxe');
        },
        itemCanBeDeleted(item) {
            return item._embed?.acl?.can_be_deleted ?? true;
        },
        rateFormatPrecision(rate) {
            this.value.rate = Number(rate);
        },
        itemCanBeUpdated(item) {
            return item._embed?.acl?.rate_can_be_updated ?? true;
        },
        onRateBlurEvent() {
            if (!this.value.id) {
                this.$emit('needRateChecking');
            }
            this.$emit('blur');
        },
        isValueRateEmpty() {
            if (value.rate) {
                return value.rate.length > 0;
            }
            return false;
        },
    },
};
</script>
<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
td .vat-manager-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid $gray-40;
    padding: 0;
    & > div {
        display: flex;
        justify-content: center;
    }
    &__text {
        width: 352px;
        &--large {
            width: 496px;
            margin-right: 16px;
            margin-left: 16px;
            .el-input .el-input__inner {
                width: 496px;
            }
        }
        .el-input__inner {
            width: 320px;
        }
    }
    &__action {
        width: 68px;
        &--switch {
            padding-bottom: 18px;
            padding-top: 18px;
        }
        .el-switch__core {
            width: 36px;
        }
    }
    &__rate {
        width: 128px;
        padding: 16px;
        &--alert-msg {
            color: $alert-50;
            font-size: 12px;
            line-height: 1;
            padding-top: 4px;
            position: absolute;
        }
    }
    &__delete {
        width: 64px;
        padding: 0;
    }
    &__anchor {
        width: 44px;
    }
    .el-input {
        font-size: 12px;
        &.is-disabled input {
            line-height: 16px;
            background: $gray-05;
            color: $gray-40 !important;
            border-color: $gray-40;
        }
    }
}
</style>
